const moment = require('moment-timezone')

moment.tz.setDefault('GMT');

export default moment;
